import { GOOGLE_ANALYTICS_ID } from './environment';
import { ThirdPartyScripts } from './third-party-scripts';

export const TagManagement = () => {
  const initTagManagement = () => {
    const { initPostHog, initDataLayer } = ThirdPartyScripts();
    initPostHog();
    initDataLayer();
  };

  const sendPageView = (properties) => {
    if (window.posthog) {
      window.posthog.capture('$pageview', properties);
    } else if (properties) {
      window.posthog_page_view_properties = properties;
    }

    if (!window.gtag) {
      const { initDataLayer } = ThirdPartyScripts();
      initDataLayer();
    }

    window.gtag('config', GOOGLE_ANALYTICS_ID, {
      allow_enhanced_conversions: true,
      allow_linker: true,
      linker: {
        domains: ['convelio.com', 'web.convelio.com'],
      },
      page_title: properties?.title || 'Website',
      page_location: window.location.href,
    });
  };

  const sendEvent = (name, properties) => {
    if (window.posthog) {
      window.posthog.capture(name, properties);
    }

    window.gtag('event', name, properties);
  };

  const enableTagManagement = () => {
    if (window.posthog) {
      window.posthog.opt_in_capturing();
    }
  };

  const disableTagManagement = () => {
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
  };

  return {
    initTagManagement,
    enableTagManagement,
    disableTagManagement,
    sendEvent,
    sendPageView,
  };
};
